"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UpdatedSuccess = exports.RemovedSuccess = exports.AddedSuccess = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _VerifiedUser = _interopRequireDefault(require("@material-ui/icons/VerifiedUser"));

var _Button = _interopRequireDefault(require("../Button"));

var makeSuccessView = function makeSuccessView(actionType) {
  return function (_ref) {
    var recoveryMethod = _ref.recoveryMethod,
        onClick = _ref.onClick;

    var _useTranslation = (0, _reactI18next.useTranslation)(),
        t = _useTranslation.t;

    var subtitle = (0, _react.useMemo)(function () {
      if (actionType === 'removed') {
        return t("recoveryMethod.success.".concat(actionType, ".").concat(recoveryMethod, ".subtitle"));
      } else {
        return t('recoveryMethod.success.subtitle');
      }
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-col justify-center text-center py-8 px-16 h-full"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-primary mb-4",
      style: {
        fontSize: '2.5rem'
      }
    }, /*#__PURE__*/_react["default"].createElement(_VerifiedUser["default"], {
      fontSize: "inherit"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-2xl font-bold mb-4"
    }, t("recoveryMethod.success.".concat(actionType, ".").concat(recoveryMethod, ".title"))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-lg font-semibold text-gray-light mb-8"
    }, subtitle), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      onClick: onClick,
      className: "w-32"
    }, t('button.done'))));
  };
};

var AddedSuccess = makeSuccessView('added');
exports.AddedSuccess = AddedSuccess;
var RemovedSuccess = makeSuccessView('removed');
exports.RemovedSuccess = RemovedSuccess;
var UpdatedSuccess = makeSuccessView('updated');
exports.UpdatedSuccess = UpdatedSuccess;
//# sourceMappingURL=Success.js.map